document.addEventListener("DOMContentLoaded", (event) => {
  var rev = $(".block__banner_slider--content--wrapper");
  rev
    .on("init", function (event, slick, currentSlide) {
      var cur = $(slick.$slides[slick.currentSlide]),
        next = cur.next(),
        prev = cur.prev();
      prev.addClass("slick-sprev");
      next.addClass("slick-snext");
      cur.removeClass("slick-snext").removeClass("slick-sprev");
      slick.$prev = prev;
      slick.$next = next;
    })
    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      //console.log('beforeChange');
      var cur = $(slick.$slides[nextSlide]);
      //console.log(slick.$prev, slick.$next);
      slick.$prev.removeClass("slick-sprev");
      slick.$next.removeClass("slick-snext");
      ((next = cur.next()), (prev = cur.prev()));
      prev.prev();
      prev.next();
      prev.addClass("slick-sprev");
      next.addClass("slick-snext");
      slick.$prev = prev;
      slick.$next = next;
      cur.removeClass("slick-next").removeClass("slick-sprev");
    });

  rev.slick({
    arrows: false,
    dots: false,
    focusOnSelect: true,
    infinite: true,
    centerMode: true,
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "0",
    swipe: true,
    cssEase: "linear",
    customPaging: function (slider, i) {
      return "";
    },
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
  });

  if ($(window).width() < 750) {
    $(".block__logo-with-link--wrapper").slick({
      slidesToShow: 1,
      centerMode: true,
      speed: 500,
      arrows: false,
      buttons: false,
    });
  }

  document
    .querySelectorAll(".block__faq-tabbing-qna--inner")
    .forEach((faq_dropdown) => {
      faq_dropdown.addEventListener("click", Faq_dropdown);
    });

  function Faq_dropdown(event) {
    const __this = event.currentTarget;
    if (__this.classList.contains("active")) {
      __this.classList.remove("active");
    } else {
      const close_dropdown = __this
        .closest(".block__faq-tabbing-qna")
        .querySelectorAll(".block__faq-tabbing-qna--inner");
      close_dropdown.forEach((el) => el.classList.remove("active"));
      __this.classList.add("active");
    }
  }

  document
    .querySelectorAll(".block__metafield--tabbing-detail")
    .forEach((product_dropdown) => {
      product_dropdown.addEventListener("click", ProductDropdown);
    });

  function ProductDropdown(event) {
    const __this = event.currentTarget;
    if (__this.classList.contains("active")) {
      __this.classList.remove("active");
    } else {
      const close_dropdown = __this
        .closest(".block__metafield--tabbing")
        .querySelectorAll(".block__metafield--tabbing-detail");
      close_dropdown.forEach((el) => el.classList.remove("active"));
      __this.classList.add("active");
    }
  }

  var play_icon = document.querySelector(
    ".block__image-video-element-btn-icon",
  );
  var video = document.querySelector(".block__image-video-element");
  if (play_icon != null) {
    play_icon.addEventListener(
      "click",
      function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      },
      false,
    );
  }
  $("a").on("click", function (event) {
    if (this.hash !== "") {
      var hash = this.hash;
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        500,
        function () {
          window.location.hash = hash;
        },
      );
    }
  });
  if (document.querySelector(".block__customer-pref-team-edits") !== null) {
    document
      .querySelector(".block__customer-pref-team-edits")
      .addEventListener("click", function () {
        document.getElementById("popup-team-select").classList.add("open");
        document.body.classList.add("overflow-hidden");
      });
  }
  if (document.querySelector(".block__customer-popup-close") !== null) {
    document
      .querySelector(".block__customer-popup-close")
      .addEventListener("click", function () {
        document.getElementById("popup-team-select").classList.remove("open");
        document.body.classList.remove("overflow-hidden");
      });
  }
  if (
    document.querySelector(".block__customer-pref-team-popup .overlay") !== null
  ) {
    document
      .querySelector(".block__customer-pref-team-popup .overlay")
      .addEventListener("click", function () {
        document.getElementById("popup-team-select").classList.remove("open");
        document.body.classList.remove("overflow-hidden");
      });
  }
  if (
    document.querySelectorAll(".block__prefrence-team-name-heading") !== null
  ) {
    document
      .querySelectorAll(".block__prefrence-team-name-heading")
      .forEach((team_dropdown) => {
        team_dropdown.addEventListener("click", Team_dropdown);
      });
  }

  function Team_dropdown(event) {
    var __this = event.currentTarget;
    if (
      __this
        .closest(".block__prefrence-team-name-main")
        .classList.contains("active")
    ) {
      __this
        .closest(".block__prefrence-team-name-main")
        .classList.remove("active");
    } else {
      var close_dropdown = __this
        .closest(".block__customer-pref-team-popup-content")
        .querySelectorAll(".block__prefrence-team-name-main");
      close_dropdown.forEach((el) => el.classList.remove("active"));
      __this
        .closest(".block__prefrence-team-name-main")
        .classList.add("active");
    }
  }

  ("use strict");
  const targetElements = document.querySelectorAll(".already-purchased");
  targetElements.forEach(function (targetElement) {
    targetElement.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });
});

$(document).on("click", ".block__prefrence-all-team-name input", function () {
  $(this)
    .closest(".block__prefrence-all-team-name")
    .find("input")
    .prop("checked", false);
  $(this).prop("checked", true);
});

$(document).on("click", ".block__prefrence-team-select-btn", function () {
  var $this = $(this);
  $this.addClass("loading");
  $this.find(".loading__spinner").removeClass("hidden");

  if (
    typeof window.customerId === "undefined" ||
    typeof window.customerTags === "undefined"
  ) {
    console.error("Customer ID or tags are not defined.");
    return;
  }

  var currentTags = window.customerTags;

  // Collect the selected preferences
  var selectedPreferences = [];
  $('.block__prefrence-all-team-name input[type="checkbox"]:checked').each(
    function () {
      var preference = $(this).val().trim();
      var preference_tag = $(this)
        .closest(".block__prefrence-team-name-main")
        .find(".block__prefrence-team-name-heading p")
        .attr("data-team-name");
      preference_tag = preference_tag + "Team_" + preference;
      selectedPreferences.push(preference_tag);
      console.log("Selected preference:", preference_tag);
    },
  );

  var birthdate = $("#datepicker").val();
  if (birthdate !== "") {
    selectedPreferences.push("Birthdate_" + birthdate);
  }

  // Filter out old Team_ and Birthdate_ tags from currentTags
  var updatedTags = currentTags
    .filter((tag) => !tag.includes("Team_") && !tag.includes("Birthdate_"))
    .concat(selectedPreferences);

  // Remove duplicates
  updatedTags = [...new Set(updatedTags)];

  var payload = {
    customer: {
      id: window.customerId,
      tags: updatedTags.join(", "),
    },
  };

  console.log("Payload", JSON.stringify(payload));

  // Send the data to the endpoint
  $.ajax({
    url:
      "https://func-inbound-lids-int-loyaltyportal-prod.azurewebsites.net/api/customer/" +
      window.customerId +
      "/tags/?code=oV2C7aEP6GS4Gg5nZ48IVjFYNu1jblYHOsf6wj3Wc89pAzFuIGOhUQ%3D%3D",
    type: "PUT",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (response) {
      console.log("Customer tags updated successfully:", response);
      $this.text("Preferences Updated");
      $this.addClass("team-saved");
      $this.removeClass("loading");
      $this.find(".loading__spinner").addClass("hidden");
      setTimeout(function () {
        location.reload();
      }, 2000);
    },
    error: function (xhr, textStatus, errorThrown) {
      console.error("Error updating customer tags:", errorThrown);
      $this.removeClass("loading");
      $this.find(".loading__spinner").addClass("hidden");
    },
  });
});
document.addEventListener("DOMContentLoaded", () => {
  $(".block__video-with-text-slider-wrapper").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    buttons: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".block__banner-timer--main").forEach((event) => {
    var __this = event;
    var custom_date = __this.getAttribute("data-date");
    if (custom_date !== null && custom_date !== "") {
      var countDownDate = new Date(custom_date).getTime();
      var myfunc = setInterval(function () {
        var now = new Date().getTime();
        var timeleft = countDownDate - now;
        var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
        if (timeleft < 0) {
          clearInterval(myfunc);
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelectorAll(".block__timer--announcement")
            .forEach((event) => {
              event.style.display = "none";
            });
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector(".block__timer--over-text").style.display = "block";
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector("#end").innerHTML = "TIME UP!!";
        } else {
          if (days < 10) {
            days = "0" + days;
          }
          if (hours < 10) {
            hours = "0" + hours;
          }
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          if (seconds < 10) {
            seconds = "0" + seconds;
          }
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector("#days").innerHTML = days;
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector("#hours").innerHTML = hours;
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector("#mins").innerHTML = minutes;
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector("#secs").innerHTML = seconds;
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelectorAll(".block__timer--announcement")
            .forEach((event) => {
              event.style.display = "block";
            });
          __this
            .closest(".block__banner-timer-subtitle")
            .querySelector(".block__timer--over-text").style.display = "none";
        }
      }, 1000);
    }
  });
});

// custom slider arrow click on launch custom page
$(document).on(
  "click",
  ".block__video-with-text-slider-arrow-left",
  function () {
    $(this)
      .closest(".block__video-with-text-slider-main")
      .find(".slick-prev")
      .trigger("click");
  },
);
$(document).on(
  "click",
  ".block__video-with-text-slider-arrow-right",
  function () {
    $(this)
      .closest(".block__video-with-text-slider-main")
      .find(".slick-next")
      .trigger("click");
  },
);

document.addEventListener("DOMContentLoaded", () => {
  if ($(window).width() < 750) {
    $(".block__productgrid--slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      buttons: false,
      responsive: [
        {
          breakpoint: 371,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});
